import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import { Flex, Text } from '../components';
import * as S from '../styles';

export const QuestionLabel = styled(S.QuestionLabel)`
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #464d5d;
`;

export const FieldWrapper = styled(Flex)`
  margin-bottom: 20px;
  flex-direction: column;
`;

export const Input = styled(S.Input)`
  &[type='text'] {
    width: 300px;
    padding: 8px 16px;
    border-radius: 8px;
    height: 40px;
  }
`;

export const RadioInput = styled(S.Input)`
  width: 20px;
`;

export const RadioLabel = styled(S.RadioLabel)`
  font-size: 14px;
  margin-left: 8px;
  color: #464d5d;
`;

export const SecondaryButton = styled(S.SecondaryButton)`
  width: 200px;
  padding: 4px 10px;
`;

export function Error({ errors, fieldName }) {
  const fieldErrors = get(errors, fieldName);
  const errorText = fieldErrors ? <Text variant='error'>{fieldErrors.message}</Text> : null;
  return errorText;
}
